import { Dropdown, TextInput } from 'components/common'
import {
  ftpProtocolOptions,
  FTP_PROTOCOLS,
  getNestErrorMessage,
} from 'components/aggregatorManagement/utils'
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { chainFormFields } from './utils'
import { useEffect } from 'react'

const {
  FTP_PROTOCOL,
  FTP_HOST,
  FTP_PORT,
  FTP_USERNAME,
  FTP_PASSWORD,
  FTP_BASE_DIRECTORY,
} = chainFormFields

interface ChainFtpConfigFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  setValue: UseFormSetValue<any>
  chain?: any
}

const ChainFtpConfigForm = ({
  register,
  errors,
  setValue,
  chain,
}: ChainFtpConfigFormProps) => {
  useEffect(() => {
    setValue(
      FTP_PROTOCOL.parentKey + '.' + FTP_PROTOCOL.key,
      chain?.ftp?.protocol ?? FTP_PROTOCOLS.FTP,
    )
  }, [chain])

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-2 mid-md:flex-row mid-md:gap-5">
        <Dropdown
          required
          setValue={setValue}
          options={ftpProtocolOptions}
          defaultValue={chain?.ftp?.protocol ?? FTP_PROTOCOLS.FTP}
          label={FTP_PROTOCOL.label}
          name={FTP_PROTOCOL.parentKey + '.' + FTP_PROTOCOL.key}
          error={getNestErrorMessage(errors, FTP_PROTOCOL)}
        />

        <TextInput
          required
          register={register}
          label={FTP_HOST.label}
          name={FTP_HOST.parentKey + '.' + FTP_HOST.key}
          error={getNestErrorMessage(errors, FTP_HOST)}
        />

        <TextInput
          required
          register={register}
          label={FTP_PORT.label}
          name={FTP_PORT.parentKey + '.' + FTP_PORT.key}
          error={getNestErrorMessage(errors, FTP_PORT)}
        />
      </div>

      <div className="flex flex-col gap-2 mid-md:flex-row mid-md:gap-5">
        <TextInput
          required
          register={register}
          label={FTP_USERNAME.label}
          name={FTP_USERNAME.parentKey + '.' + FTP_USERNAME.key}
          error={getNestErrorMessage(errors, FTP_USERNAME)}
        />

        <TextInput
          required
          type="password"
          register={register}
          label={FTP_PASSWORD.label}
          name={FTP_PASSWORD.parentKey + '.' + FTP_PASSWORD.key}
          error={getNestErrorMessage(errors, FTP_PASSWORD)}
        />
      </div>

      <TextInput
        required
        register={register}
        label={FTP_BASE_DIRECTORY.label}
        name={FTP_BASE_DIRECTORY.parentKey + '.' + FTP_BASE_DIRECTORY.key}
        error={getNestErrorMessage(errors, FTP_BASE_DIRECTORY)}
      />
    </div>
  )
}

export default ChainFtpConfigForm
